import React from "react"
import {connect} from "react-redux"
import {useNavigate} from "react-router-dom"

import {gameActions} from "../../service"

import {GameCreateForm} from "../../components/forms"


function GameCreate({gameClear}) {


    const navigate = useNavigate()

    function onFinish() {
        gameClear()
        navigate("../")
    }

    //return  <GameCreateSections />

    return <GameCreateForm onFinish={onFinish}/>

}

export default connect(null, {
    gameClear: gameActions.actions.clear
})(GameCreate)